$(function () {
	$('.form-table-repeatable').each(function () {
		const $table = $(this);
		const $body = $table.find('.form-table-body');
        const $rowBase = $body.find('.form-table-row').first().clone();
        $body.find('.form-table-row').remove();
		toggleButtonStates($table);

		$(this).siblings('.form-table-add').on('click', function (e) {
			e.preventDefault();
			createNewRow($rowBase, $body);
			toggleButtonStates($table);
		});

		$(this).on('click', '.form-table-delete', function (e) {
			e.preventDefault();
			deleteRow($(this).closest('.form-table-row'));
			toggleButtonStates($table);
		});

		$('#EnrollChildren').on('change', function () {
            $body.find('.form-table-row').remove();
			if ($(this).prop('checked')) {
				$('#enroll-children-table').show();
				createNewRow($rowBase, $body);
			} else {
				$('#enroll-children-table').hide();
			}

			toggleButtonStates($table);
		});
	});
});

function createNewRow($base, $body) {
	const $newRow = $base.clone();
	const index = $body.find('.form-table-row').length;	
	updateAllAttrs($newRow, index);
	$body.append($newRow);
}

function deleteRow($row) {
	const $next = $row.nextAll();
	const index = $row.index();

	$row.remove();

	$next.each(function (i) {
		const id = i + index + 1;
		updateAllAttrs($(this), id - 1, id);
	});
}

function updateAllAttrs($row, index, current = '0') {
	$row.find('input, select').each(function () {
		updateAttrIndex(this, 'id', index, current);
		updateAttrIndex(this, 'name', index, current);
	});

	$row.find('label').each(function () {
		updateAttrIndex(this, 'for', index, current);
	});
}

function updateAttrIndex(elem, attr, index, current = '0') {
	$(elem).attr(attr, $(elem).attr(attr).replace(current, index));
}

function toggleButtonStates($table) {
	const $body = $table.find('.form-table-body');
	const $deleteButtons = $table.find('.form-table-delete');
	const $addButtons = $table.siblings('.form-table-add');
	const count = $body.find('.form-table-row').length;
	const min = $table.data('min');
	const max = $table.data('max');

	$deleteButtons.prop('disabled', count <= min);
	$addButtons.prop('disabled', count >= max);
}